import React from 'react';
import Loading from '../components/Loading';
import Messaging from '../components/Messaging';
import { useClientData } from '../hooks/useClientData';

const ClientMessagesPage: React.FC = () => {
  const { clientId, userEmail, loading, client, dietitian } = useClientData({
    fetchAppointments: false,
    fetchDietPrograms: false,
    fetchDietitian: true,
  });

  if (loading || !clientId) {
    return (
      <Loading
        size="large"
        variant="wave"
        mode="inline"
        message="Mesajlar yükleniyor..."
      />
    );
  }

  const currentUserName = client ? `${client.firstName} ${client.lastName}` : userEmail;

  return (
    <Messaging
      currentUserId={clientId}
      currentUserName={currentUserName}
      isDietitian={false}
      dietitian={dietitian ?? undefined}
    />
  );
};

export default ClientMessagesPage;
